export default "__VITE_ASSET__CbmrQ3Rx__"